import { useTranslation } from 'react-i18next';
import { AlloyButton, Modal } from 'cat-ecommerce-alloy';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  editPendingQuote,
  setCloseSystemFeedback
} from '@app/store/account/actions';
import { useSystemFeedback } from '@app/hooks';
import { pendingQuoteStatePropType } from '../../account/common/PendingQuotesTable/declarations.propTypes';
import { ERROR_PATH, ERROR_DOMAIN } from '@app/constants/errorConstants';
import { PCC_HEADLESS_SHOPPING_CART_FLAG } from '@app/constants/featureFlags';
import { headlessLinks } from '@app/constants/links';
import { replaceTokensInString, normalizeUrl } from '@app/utils';

const EditQuoteModal = ({ item, close, isOpen, errorDomain }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setError, clearError } = useSystemFeedback();
  const esiteURL = useSelector(s => s.common?.esiteURL);
  let isHeadlessShoppingCartEnabled = useSelector(
    s => s.featureFlag?.[PCC_HEADLESS_SHOPPING_CART_FLAG]
  );
  // CSR - temporary fix - Bug: 1480998 - Remove after CSR implementation.
  const isBuyOnBehalf = useSelector(s => s.common?.isBuyOnBehalf) || false;
  const isCatCSR = useSelector(s => s.common?.isCatCSR) || false;

  const getLinkUrl = url => {
    const linkEndpoint = replaceTokensInString(url, esiteURL);
    return normalizeUrl(linkEndpoint);
  };
  const shoppingCartHeadlessURL = getLinkUrl(
    headlessLinks.HEADLESS_SHOPPING_CART_LINK
  );

  // CSR - temporary fix - Bug: 1480998 - Remove after CSR implementation.
  const isCSRAgent = isBuyOnBehalf || isCatCSR;
  if (isCSRAgent) {
    isHeadlessShoppingCartEnabled = false;
  }

  const errorPath =
    errorDomain === ERROR_DOMAIN.CONTROL_CENTER
      ? ERROR_PATH.PENDING_QUOTES_WIDGET_ACTIONS
      : ERROR_PATH.PENDING_QUOTE_SEARCH_PAGE_ACTIONS;

  const handleContinueClick = async () => {
    close();
    dispatch(setCloseSystemFeedback(false));
    try {
      dispatch(clearError(errorDomain, errorPath));
      await dispatch(
        editPendingQuote(
          item.orderId,
          isHeadlessShoppingCartEnabled,
          shoppingCartHeadlessURL
        )
      );
    } catch (err) {
      const errorMessage = {
        message: `${t('UNKNOWN_ERROR_MESSAGE')} ("${t('ORDER')} ${
          item.orderId
        }")`
      };
      setError(errorDomain, errorPath, errorMessage);
    }
  };

  return (
    <Modal
      close={close}
      isOpen={isOpen}
      title={t('WARNING_DO_YOU_WISH_TO_PROCEED')}
    >
      <div>
        <p className="u-color--DarkGray u-fs--16 my-1">
          {t('EDIT_QUOTE_WARNING')}
        </p>
        <div className="d-flex flex-md-row-reverse flex-column mt-2">
          <AlloyButton
            buttonType="primary"
            size="dynamic"
            onClick={handleContinueClick}
          >
            {t('EF_CONTINUE')}
          </AlloyButton>

          <AlloyButton
            size="dynamic"
            buttonType="ghost"
            onClick={close}
            className="mt-md-0 mt-2"
          >
            {t('MO_CancelButton')}
          </AlloyButton>
        </div>
      </div>
    </Modal>
  );
};
export default EditQuoteModal;
EditQuoteModal.propTypes = {
  item: pendingQuoteStatePropType,
  close: PropTypes.func,
  isOpen: PropTypes.bool,
  errorDomain: PropTypes.string
};
